<template>
  <div>
    <Row>
      <Col span="11">
        <FormItem  prop="name" :label="$t( 'resourceLifecycle.vPCName' )">
          <Input v-model="resourceApplicationForm.name" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem  prop="IPV4" :label="$t( 'resourceLifecycle.vPCIPv4CIDRblock' )">
          <Input v-model="resourceApplicationForm.IPV4" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem  prop="IPV6" :label="$t( 'resourceLifecycle.iPv6CIDRblock' )">
          <RadioGroup v-model="resourceApplicationForm.IPV6">
            <Radio v-for="list in IPV6List" :label="list.IPV6" :key="list.value">{{list.label}}</Radio>
          </RadioGroup>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem  prop="hardwareLease" :label="$t( 'resourceLifecycle.hardwareRental' )">
          <Select v-model="resourceApplicationForm.hardwareLease" filterable>
            <Option :value="item.id" v-for="(item,index) in hardwareLeaseList" v-bind:key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem  prop="subnetName" :label="$t( 'resourceLifecycle.subnetNameLabel' )">
          <Input v-model="resourceApplicationForm.subnetName" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
      <Col span="11">
        <FormItem  prop="availableArea" :label="$t( 'resourceLifecycle.availabilityZones' )">
          <Select v-model="resourceApplicationForm.availableArea" filterable>
            <Option :value="item.zoneName" v-for="(item,index) in availabilityZoneList" v-bind:key="item.zoneName">{{item.zoneName}}</Option>
          </Select>
        </FormItem>
      </Col>
    </Row>

    <Row>
      <Col span="11">
        <FormItem  prop="subnetIPV4" :label="$t( 'resourceLifecycle.subnetIPv4CIDRblock' )">
          <Input v-model="resourceApplicationForm.subnetIPV4" :placeholder="$t( 'resourceLifecycle.pleaseenter' )"/>
        </FormItem>
      </Col>
    </Row>
  </div>
</template>

<script>
  import {setCookie,getCookie,delCookie} from '../../../../../utils/cookieUtil.js'
  export default {
    name: 'AmazonVirtualNetwork',
    props: ['amazonResourceApplicationBasicInfoForm'],
    components: {},
    data () {
      return {
        hardwareLeaseList:[{
          id:0,
          name:'default'
        },{
          id:1,
          name:'dedicated'
        },{
          id:2,
          name:'host'
        }],
        availabilityZoneList:[],
        IPV6List: [{
          label: this.$t( 'resourceLifecycle.noIPv6CIDRblock'),
          value: 'No IPv6 CIDR block',
          IPV6: 1
        }, {
          label: this.$t( 'resourceLifecycle.ipv6CIDRblockprovidedbyAmazon'),
          value: 'Amazon-provided IPv6 CIDR block',
          IPV6: 0
        }],
        resourceApplicationForm: {
          name:'',
          IPV4:'',
          IPV6:0,
          hardwareLease:0,
          subnetName:'',
          availableArea:'',
          subnetIPV4:''
        },
        ruleValidate: {
          name: [
            {required: true, message: this.$t( 'resourceLifecycle.namecannotbeempty' ), trigger: 'blur'}
          ],
          IPV4: [
            {required: true, message: this.$t( 'resourceLifecycle.vPCIPV4CIDRblockcannotbeempty' ), trigger: 'blur'}
          ],
          subnetIPV4: [
            {required: true, message: this.$t( 'resourceLifecycle.subnetIPv4CIDRblockcannotbeempty' ), trigger: 'blur'}
          ],
          IPV6: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectIPv6CIDRblock' ), trigger: 'change', type: 'number'}
          ],
          hardwareLease: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectHardwareRental' ), trigger: 'change', type: 'number'}
          ],
          subnetName: [
            {required: true, message: this.$t( 'resourceLifecycle.subnetnametagcannotbeempty' ), trigger: 'blur'}
          ],
          availableArea: [
            {required: true, message: this.$t( 'resourceLifecycle.pleaseselectanAvailabilityZone' ), trigger: 'change'}
          ]
        }
      }
    },
    mounted: function () {
    },
    methods: {
      showAll: function () {
        //查询AWS可用区
        this.queryAWSAvailableZoneList();
      },
      //查询AWS可用区
      queryAWSAvailableZoneList: function () {
        this.$api.lifecycleResourceApplication.queryAWSAvailableZoneList({
          "accountId": this.amazonResourceApplicationBasicInfoForm.accountId,
          "region": this.amazonResourceApplicationBasicInfoForm.region
        })
          .then(res => {
            if(res.data){
              this.availabilityZoneList = res.data;
              this.resourceApplicationForm.availableArea=this.availabilityZoneList[0].zoneName;
            }

          })
      }
    }
  }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/aws/virtual_network/AmazonVirtualNetwork.vue